import isEqual from "lodash/isEqual"
import { computed } from "vue"
import { mapState } from "vuex"
import { categories } from "@/lib/ListingFilters"

export default function useCategoriesCount() {
  const filters = mapState("filter", {
    mediums: ({ filters }) => filters.mediums,
  })

  const mediums = computed(filters.mediums)

  const appliedCategoriesCounter = computed(() => {
    return Object.keys(categories).some((key) => {
      if (categories[key].length !== 0 && categories[key].length === mediums.value.length) {
        return isEqual(categories[key], mediums.value)
      }
    })
      ? 1
      : 0
  })

  return computed(() => ({
    badgeContent: appliedCategoriesCounter.value,
    badgeCondition: appliedCategoriesCounter.value,
  }))
}
